import type { CSSProperties } from 'react'
import { cn } from '@/shared/lib/cn'
import { Icon } from '@/shared/ui'
import { clientChannelLook, isPaleChannelTile } from '../model/channel'
import s from './ClientChannelTile.module.css'

type ClientChannelTileProps = {
  /** Тип канала с сервера. Открытая строка: незнакомый уедет в нейтральный вид, а не сломает плитку. */
  kind: string
  className?: string
}

/**
 * Плитка канала связи. Геометрия — та же, что у плитки мессенджера в переписке и в брони (30px,
 * радиус 8, иконка 16), чтобы строки каналов выглядели одинаково по всему приложению.
 *
 * Своя, а не переиспользованная `MessengerAvatar`: FSD запрещает импорт сущности из сущности, и
 * это здесь не формальность — `ChannelKind` вдвое дробнее `Messenger` («телефон в Telegram» и
 * «ник в Telegram» — разные каналы), так что общего типа у них всё равно нет. Совпадение вида
 * держится на общих токенах палитры, а не на общем компоненте.
 */
export function ClientChannelTile({ kind, className }: ClientChannelTileProps) {
  const look = clientChannelLook(kind)

  return (
    <span
      className={cn(s.root, isPaleChannelTile(look) && s.pale, className)}
      style={{ '--tint': look.token } as CSSProperties}
      aria-hidden="true"
    >
      <Icon name={look.icon} size={16} />
    </span>
  )
}
